import backendServices from '@department-of-veterans-affairs/platform-user/profile/backendServices';
import { toggleValues } from '@department-of-veterans-affairs/platform-site-wide/selectors';
import FEATURE_FLAG_NAMES from '@department-of-veterans-affairs/platform-utilities/featureFlagNames';

export const isLoadingFeatures = state => toggleValues(state).loading;

// Feature toggles

// 'cst_include_ddl_boa_letters'
export const cstIncludeDdlBoaLetters = state =>
  toggleValues(state)[FEATURE_FLAG_NAMES.cstIncludeDdlBoaLetters];

// 'cst_include_ddl_5103_letters'
export const cstIncludeDdl5103Letters = state =>
  toggleValues(state)[FEATURE_FLAG_NAMES.cstIncludeDdl5103Letters];

// 'cst_use_dd_rum'
export const cstUseDataDogRUM = state =>
  toggleValues(state)[FEATURE_FLAG_NAMES.cstUseDataDogRUM];

// 'cst_multi_claim_provider'
export const cstMultiClaimProvider = state =>
  toggleValues(state)[FEATURE_FLAG_NAMES.cstMultiClaimProvider];

// 'cst_surface_closed_tracked_items'
export const cstSurfaceClosedTrackedItems = state =>
  toggleValues(state)[FEATURE_FLAG_NAMES.cstSurfaceClosedTrackedItems];

// 'benefits_claims_provider_eligibility'
export const benefitsClaimsProviderEligibility = state =>
  toggleValues(state)[FEATURE_FLAG_NAMES.benefitsClaimsProviderEligibility];

// Backend Services
export const getBackendServices = state => state.user.profile.services;

// Services that grant access to claims data. benefitsClaims is only honored
// when the provider eligibility flag is on.
export const getClaimsServices = benefitsClaimsEnabled =>
  benefitsClaimsEnabled
    ? [backendServices.LIGHTHOUSE, backendServices.BENEFITS_CLAIMS]
    : [backendServices.LIGHTHOUSE];

export const hasClaimsAccess = state =>
  getClaimsServices(benefitsClaimsProviderEligibility(state)).some(service =>
    getBackendServices(state).includes(service),
  );
